import { TaskItem, TaskList } from '@tiptap/extension-list';
import { MarkdownManager } from '@tiptap/markdown';
import StarterKit from '@tiptap/starter-kit';

let markdownManager: MarkdownManager | null = null;

export function getMarkdownManager(): MarkdownManager {
  if (!markdownManager) {
    markdownManager = new MarkdownManager({
      extensions: [StarterKit, TaskList, TaskItem.configure({ nested: true })],
    });
  }
  return markdownManager;
}
